var $90c9806f64d6cfe1$exports = {};
$90c9806f64d6cfe1$exports = {
    "replaceMessage": `Drop file to replace`
};


export {$90c9806f64d6cfe1$exports as default};
//# sourceMappingURL=en-US.mjs.map
